import { Mixin } from 'mixwith';

export default Mixin(
  (superclass) =>
    class extends superclass {
       
      parseTextNode(textContent) {
        return {
          type: 'text',
          content: textContent || '',
        };
      }
    },
);
